import goTopButton from '@/components/GoTopButton'
import { showAccountDetails, showCardDetails, showOrderDetails } from '@/tools/utils.js'

export default {

  components: {
    goTopButton
  },

  data () {
    return {
      responseErr: null,
      isProcessing: false,
      operationRequest: null
    }
  },

  created () {
    this.getDetail(this.$store.state.operations.operation)
  },

  methods: {
    async getDetail (operationRequest) {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('operations/detailReset')
      await this.$store.dispatch('operations/detail', operationRequest).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    showAccount (accountDetailsPageContext) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountDetailsPageContext[0],
        distributorRef: this.$store.state.accounts.account.distributorRef,
        beneficiaryServiceRef: accountDetailsPageContext[2],
        issuerId: accountDetailsPageContext[1]
      })
      return showAccountDetails()
    },

    showCard (card) {
      this.$store.dispatch('cards/setCard', { card: card })
      return showCardDetails()
    },

    showOrder (order) {
      this.$store.dispatch('orders/setOrder', order)
      return showOrderDetails()
    }
  }
}
